import { render } from "./ChoosePlanV15.vue?vue&type=template&id=3c5fcc3c"
import script from "./ChoosePlanV15.vue?vue&type=script&lang=ts"
export * from "./ChoosePlanV15.vue?vue&type=script&lang=ts"

import "./ChoosePlanV15.vue?vue&type=style&index=0&id=3c5fcc3c&lang=scss"
script.render = render

export default script